<template>
  <div class="uploading">
    <el-upload
      ref="upload"
      :format="['pdf']"
      accept=".pdf, .PDF"
      :show-file-list="false"
      :action="uploadHost"
      :data="uploadData"
      :before-upload="beforeUpload"
      :on-success="handleSuccess"
      :clearFiles="clearFiles"
      :file-list="file_list"
      :on-error="handleFormatError"
    >
      <span slot="trigger">上传文件</span>
    </el-upload>
  </div>
</template>

<script>
// 引入生成上传参数方法
import { oss } from "@/libs/uploadFile";
import { getpublicImgUrl } from "@/api/base/api-upload";
export default {
  data() {
    return {
      // 附件上传路径
      uploadHost: "",
      type: 0,
      path: "public/product/",
      // 附件上传携带参数
      uploadData: {},
      fileData: {
        // 上传后返回的存储的文件名
        fileName: "",
        oFileName: "",
        fileUrl: "",
        uploadRes: null,
      },
      file_list: [],
    };
  },
  methods: {
    beforeUpload(file) {
      return oss(file.name, this.type, this.path).then((res) => {
        this.uploadHost = res.host;
        this.uploadData = res;
        this.fileData.fileName = res.key;
        this.fileData.oFileName = file.name;
        this.fileData.fileUrl = res.key;
      });
    },
    // 上传成功的回调函数
    handleSuccess(res, file, fileList) {
      this.uploadRes = res;
      if (this.type === 0) {
        // 获取公有链接
        getpublicImgUrl(this.fileData.fileName).then((res) => {
          if (res.code === 0) {
            this.fileData.fileUrl = res.data;
            this.fileData.name = this.fileData.fileName;
            this.fileData.url = res.data;
            this.$emit("input", res.data);
          } else {
            this.$message.success("获取图片链接失败");
          }
        });
      }
    },
    clearFiles() {
      this.fileData = {
        fileName: "",
        fileUrl: "",
        uploadRes: null,
      };
      this.file_list = [];
    },
    handleFormatError(file) {
      this.$message({
        message: "图片格式错误",
        type: "warning",
      });
    },
  },
};
</script>